const BASE_URL = `http://web.solar-manager.ch`;

const authorize = () => {
  window.location.href = `${BASE_URL}/basic/authorize`;
};

export default authorize;
